<script>
	import { onMount } from 'svelte';

	onMount(() => {
		const script = document.createElement('script');
		script.type = 'text/javascript';

		const code = `(function (w, d, s, l, i) {
			w[l] = w[l] || [];
			w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
			var f = d.getElementsByTagName(s)[0],
				j = d.createElement(s),
				dl = l != 'dataLayer' ? '&l=' + l : '';
			j.async = true;
			j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
			f.parentNode.insertBefore(j, f);
		})(window, document, 'script', 'dataLayer', 'GTM-WP3BBL8N');`;

		// https://stackoverflow.com/questions/6432984/how-to-add-a-script-element-to-the-dom-and-execute-its-code
		try {
			script.appendChild(document.createTextNode(code));
			document.head.appendChild(script);
		} catch {
			script.text = code;
			document.head.appendChild(script);
		}

		// Your GTM <body> script here, but in a way that programmatically creates the elements
		// For example, if your GTM body code is something like:
		// <noscript><iframe src="..."></iframe></noscript>
		// You'd translate it into:
		//<!-- Google Tag Manager (noscript) -->
		//<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KR9JRCKD"
		//                  height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
		//<!-- End Google Tag Manager (noscript) -->

		const noscript = document.createElement('noscript');
		const iframe = document.createElement('iframe');
		iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-WP3BBL8N'; // your iframe src from GTM
		iframe.height = '0';
		iframe.width = '0';
		iframe.style.display = 'none;visibility:hidden';
		noscript.appendChild(iframe);

		document.body.prepend(noscript);

		return () => {
			noscript.remove();
		};
	});
</script>
